import { GET_USER_INFO, GET_PERMISSION } from './types';

const initialState = {
  userId: '',
  userName: '',
  avatar: '',

  Menus: [],
  permissionModuleList: {},
};

const reducer = (state = initialState, actions) => {
  switch (actions.type) {
    case GET_USER_INFO:
      state.userId = actions.payload.id;
      state.userName = actions.payload.userName;
      state.avatar = actions.payload.avatar;
      return { ...state };
    case GET_PERMISSION: {
      state.Menus = actions.payload.Menus;
      state.permissionModuleList = actions.payload.permissionModuleList;
      return { ...state };
    }
    default:
      return { ...state };
  }
};

export default reducer;
